export default "__VITE_ASSET__B$_HiZiL__"